define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var BaseCategoriesPanelViewController = require('web-agent-viewControllers/BaseCategoriesPanelViewController');

    var SecureFormPanel = BaseCategoriesPanelViewController.extend({
        ControllerName: "SecureFormPanel",
        applicationType: "SecureFormPanel",
        LPViewClasses: {
            loading: "loading"
        },
        LPViewMap: {},
        initialize: function (constructorData) {
            this.modelController = constructorData.modelController;

        }, events: function () {
            this.bindModel({
                modelPath: lpSecureFormsController.SECURE_FORMS_ROOT_MODEL_PATH,
                callback: this.updateContent
            });
        },
        render: function () {
        }
    });

    window.lpTag.WebAgent.SecureFormPanelViewController = SecureFormPanel;

    SecureFormPanel.prototype.dataRenderer = {

        numberOfSections: function () {
            return 1;
        },
        numberOfRowsInSection: function (data) {
            return data.length || 0;
        },
        dataForRowInSection: function (data, rowIndex) {
            var rowData = data[rowIndex];
            return {
                text: rowData.name,
                details: '',
                hotkey: '',
                type: 'text',
                rowData: rowData,
                title: this.translate('secure_forms_tooltip')
            };
        },

        filterRow: function (data, filterText) {
            if (!filterText) {
                return false;
            }

            var lowerFilterText = filterText.toLowerCase();

            if (data.name && data.name.toLowerCase() == lowerFilterText) {
                return false;
            }

            var split = lowerFilterText.split(' ');

            for (var index = 0; index < split.length; index++) {
                var partialName = data.name.toLowerCase().indexOf(split[index]) >= 0;
                if (!partialName) {
                    return true;
                }
            }

            return false;
        },

        getPropertiesForHighlight: function () {
            return {
                text: true,
                details: true
            };
        }


    };

    SecureFormPanel.prototype.dataBinder =  _.merge({},BaseCategoriesPanelViewController.prototype.dataBinder, {
        rowClicked: function (data) {
            var chatId = getChatId(this);
            var isChatOwner = this.modelController.getModelParam('chats.' + chatId + '.visitorInfo.acceptedEngagement');
            if(isChatOwner){
                var agentName = this.modelController.getModelParam('agent.agentName');
                var reqObj = {
                    chatId: chatId,
                    dialogId: lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(chatId),
                    visitorId: this.focusedVisitorId,
                    text: this.translateObj('secure_form_send_event_text', [{
                        isTranslate: false,
                        key: agentName
                    }, {
                        isTranslate: false,
                        key: data.rowData.name
                    }]),
                    args: {
                        secureFormId: data.rowData.id,
                        secureFormName: data.rowData.name
                    }
                };
                lpTag.WebAgent.secureFormsController.sendSecureFormRequest(reqObj);
            }

            // we are taking the last id from the chat's - this is the way we are doing it in the system.
            // we only have one instance of working chat per visitor. so the last is the active one.
            function getChatId(context) {
                var chatsPath = lpTag.WebAgent.logicController.getParticipantPath(context.focusedVisitorId) + '.chats';
                var chats = context.modelController.getModelParam(chatsPath);

                var chatList = lpUtils.objectKeysArray(chats);
                if (chatList) {
                    var lastChatId = lpUtils.objectKeysArray(chats).pop();
                    return lastChatId;
                }

                return null;
            }

        }
    });

    SecureFormPanel.prototype.getConfiguration = function () {
        return {
            cssClass: "secureFormsPanel",
            rootModelPath: lpSecureFormsController.SECURE_FORMS_ROOT_MODEL_PATH,
            textPrefix: "secure_forms_list",
            tableConfig: {
                rowTemplateFile: "LP_recommended_content_item.html",
                noDataTemplate: "LP_recommended_content_no_data.html",
                rootModelPath: lpSecureFormsController.SECURE_FORMS_ROOT_MODEL_PATH,
                sectionOwnerIdTag: null,
                preventSubmitByEnter: true
            }
        };
    };

    SecureFormPanel.prototype.updateContent = function () {
        if (!this.focusedVisitorId) {
            return;
        }

        var secureFormsList = this.modelController.getModelParam(lpSecureFormsController.SECURE_FORMS_LIST_MODEL_PATH);
        if(secureFormsList && secureFormsList.length){
            this.categoriesTable.updateTableSectionsStateModelData(secureFormsList, this.getUiState());
            this.updateTabTitleByTableContent();
        }

    };

    /**
     * the delegate for the refresh button.
     */
    SecureFormPanel.prototype.updateDataCallback = function () {
        lpTag.WebAgent.secureFormsController.fetchData();
    };

    return SecureFormPanel;

});
